import { AppClientGetOrderSummary } from "Constants/api.constant";
import { AppClientGetOrderSummaryRequest, AppClientGetOrderSummaryResponse } from "features/order-summary/interfaces/order-summary-api.interface";
import { setLoggedIn } from "State/StateEvents";
import { store } from "State/store";
import { ResultsDTO } from "Types/ResultsDTO";
import { ApiService } from "./ApiService";

export const OrderSummaryApiSlice = ApiService.injectEndpoints({
    endpoints: builder => ({
        getOrderSummary: builder.query<AppClientGetOrderSummaryResponse, AppClientGetOrderSummaryRequest>({
            query: ({ plant, search }) => ({
                url: AppClientGetOrderSummary,
                method: 'GET',
                params: { plant, ...(search && { search }) }
            }),
            onQueryStarted: async (args, { queryFulfilled }) => {
                try {
                    await queryFulfilled;
                } catch (err: any) {
                    if (err.error.status === 401) {
                        localStorage.removeItem("cart");
                        store.dispatch(setLoggedIn(false));
                    }
                }
            },
        }),
        trackAnonymousOrder: builder.query<ResultsDTO, { orderId: string }>({
            query: ({ orderId }) => ({
                url: `/OrderSummary/track-order/${orderId}`,
                method: "GET"
            })
        }),
        trackCustomerOrder: builder.query<ResultsDTO, { orderId: string }>({
            query: ({ orderId }) => ({
                url: `/OrderSummary/track-order/customer/${orderId}`,
                method: "GET"
            })
        })
    })
});

export const { useGetOrderSummaryQuery, useLazyGetOrderSummaryQuery, useLazyTrackAnonymousOrderQuery, useLazyTrackCustomerOrderQuery } = OrderSummaryApiSlice;
